import {createContext} from "react";
import {CountryUrls} from "./countryUrls";

export type InfinigateContextType = {
    redirectTo: string | null;
    shopwareCountryCode: string | null;
    kcLocale: string | null;
    btnLinks: CountryUrls | null;
}

const defaultContextValue: InfinigateContextType = {
    redirectTo: null,
    shopwareCountryCode: null,
    kcLocale: null,
    btnLinks: null
};

const InfinigateContext = createContext<InfinigateContextType>(defaultContextValue);
export default InfinigateContext;
